import { useFormContext } from '~/hooks';
import { Params } from '~/utils/search';

export const useSearchFormContext = () => useFormContext<Omit<Params, 'page'>>();
